import { IconContent } from '@icons';

export const usersFilled: IconContent = {
    md: '<path d="M10 7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm9 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM8.5 19v-.5a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v.5h-7Zm6-7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm1.5 0a3.999 3.999 0 0 1-2.062 3.5H20v-1a3 3 0 0 0-3-3h-1.03c.02.164.03.33.03.5ZM4 15h6.062a3.999 3.999 0 0 1-2.031-4H7a3 3 0 0 0-3 3v1Z" />',
};
